<template>
  <div>
    <TypeIndexMobile
      v-if="isMobile"
      :other-links="$options.otherLinks"
      :page-description="$options.pageDescription"
      :base-url="$options.baseUrl"
      :content-data="$options.contentData"
    />
    <TypeIndexDesktop
      v-else
      :other-links="$options.otherLinks"
      :page-description="$options.pageDescription"
      :base-url="$options.baseUrl"
      :content-data="$options.contentData"
      :breadcrumb-links="$options.breadcrumbLinks"
    />
  </div>
</template>

<script>
import {
  getMutualFundTypeObject,
  generateOtherLinks,
  generateBreadcrumbLinks,
  seoMapperConstant as CONSTANT,
} from 'shared/helpers/seoMap';
import isMobile from 'shared/mixins/isMobile';
import TypeIndexMobile from '../../components/mobile/type/TypeIndex';
import TypeIndexDesktop from '../../components/desktop/type/TypeIndex';

const mutualFundTypeObject = getMutualFundTypeObject();

export default {
  name: 'TypeIndexPage',
  metaInfo() {
    return {
      title: mutualFundTypeObject.meta_title,
      meta: [
        { name: 'description', content: mutualFundTypeObject.meta_desc },
        { name: 'keyword', content: mutualFundTypeObject.meta_keyword },
      ],
    };
  },
  components: {
    TypeIndexMobile,
    TypeIndexDesktop,
  },
  mixins: [isMobile],
  otherLinks: generateOtherLinks(CONSTANT.TYPE_KEY),
  pageDescription: mutualFundTypeObject.page_desc,
  baseUrl: mutualFundTypeObject.link_url,
  contentData: mutualFundTypeObject.data,
  breadcrumbLinks: generateBreadcrumbLinks(CONSTANT.TYPE_KEY),
};
</script>
